/**
 * Development-only logging utility
 * 
 * Only logs in development mode (NODE_ENV === 'development').
 * Prevents console spam in production builds.
 * 
 * Usage:
 *   import { devLog } from '@/utils/devLog';
 *   devLog('[Component] State:', state);
 */

/**
 * Logs messages only in development mode
 * @param args - Arguments to log (same as console.log)
 */
export function devLog(...args: any[]): void {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
}

/**
 * Logs error messages (always logs, even in production)
 * Use for critical errors that need to be tracked
 * @param args - Arguments to log (same as console.error)
 */
export function devError(...args: any[]): void {
  console.error(...args);
}

/**
 * Logs warning messages only in development mode
 * Use for non-critical warnings during development
 * @param args - Arguments to log (same as console.warn)
 */
export function devWarn(...args: any[]): void {
  if (process.env.NODE_ENV === 'development') {
    console.warn(...args);
  }
}
